import type { ClientOverviewRepository } from "../repositories/ClientOverviewRepository";
import type { CurrentBalanceInsightsEntity } from "../entities/CurrentBalanceInsightsEntity";

export class GetCurrentBalanceInsightsUseCase {
  constructor(private readonly repository: ClientOverviewRepository) {}

  async execute(): Promise<CurrentBalanceInsightsEntity> {
    return this.repository.getCurrentBalanceInsights();
  }
}
